import { GatsbyImage } from "gatsby-plugin-image"
import HTMLReactParser from "html-react-parser"
import React, { useEffect, useState } from "react"

import RichText from "./richText/Parser"

function Slide({ slide }) {
  const { title, image, icon, content } = slide
  return (
    <div className="bg-charlestonGreen-500 flex flex-col pb-10 items-center sm:pb-0 sm:bg-transparent">
      {image && (
        <div className="h-36 mb-4 sm:mb-0 sm:h-full sm:absolute w-full sm:right-[60%]  sm:bottom-0 sm:top-0 md:w-2/5">
          <GatsbyImage
            className="sm:absolute sm:inset-0 w-full h-full object-cover"
            image={image?.localFile?.childImageSharp?.gatsbyImageData}
            alt={image?.altText || ""}
          />
        </div>
      )}
      <div className="relative sm:pt-[56.25%]  w-full">
        <div className="w-full h-full md:absolute inset-0 space-y-12 flex justify-end items-center">
          <div className=" px-4 md:px-8 sm:space-y-4 w-full sm:w-3/5">
            {icon?.localFile?.childImageSharp?.gatsbyImageData && (
              <GatsbyImage
                className="w-8 h-8 mb-2"
                image={icon?.localFile?.childImageSharp?.gatsbyImageData}
                alt={icon?.altText || ""}
              />
            )}
            {title && (
              <h2 className="text-lg md:text-2xl uppercase text-white font-bold mb-2">
                {title}
              </h2>
            )}
            {content && (
              <p className=" text-md md:text-xl text-white">
                {HTMLReactParser(content)}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default function SmartHero({ component }) {
  const { richtitle, subtitle, slides } = component
  const [index, setIndex] = useState(0)
  const [controlled, setControlled] = useState(slides?.length === 1 || false)

  useEffect(() => {
    if (!controlled && slides?.length) {
      const id = setInterval(() => setIndex((index + 1) % slides.length), 15000)
      return () => {
        clearInterval(id)
      }
    }
    return () => {}
  }, [controlled, index, setIndex, slides?.length])

  return (
    <>
      <div className="relative pt-12 sm:pt-16 lg:pt-24">
        <div className="relative px-4 mx-auto mb-4 sm:px-6 lg:px-8 lg:max-w-7xl">
          {richtitle && <RichText stringHtml={richtitle} option="heroTitle" />}
          {subtitle && (
            <p className="font-bold leading-tight	 text-lg text-gray-900">
              {HTMLReactParser(subtitle)}
            </p>
          )}
        </div>
      </div>
      <div className="relative bg-greenGrey-100">
        <div className=" mx-auto lg:max-w-7xl">
          {slides?.length && (
            <div className="mt-4 md:mt-8">
              <Slide slide={slides[index]} />
              {slides.length > 1 && (
                <ul className="absolute flex gap-4 -translate-x-1/2 left-1/2 bottom-4">
                  {slides.map((slide, key) => (
                    <li
                      key={slide}
                      className={`flex h-2 md:h-3 w-2 md:w-3 bg-white rounded-xl ${
                        key === index && "bg-orangeSafe-500"
                      }`}
                    >
                      <button
                        type="submit"
                        aria-label={slide.title}
                        className="w-full h-full"
                        onClick={() => {
                          setIndex(key)
                          setControlled(true)
                        }}
                      />
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  )
}
